import {computed, makeObservable} from "mobx";
import SaporeForm from "../forms/SaporeForm";
import OptionField from "../forms/fields/OptionField";

export default class CommercialTermsForm extends SaporeForm {
    static newEmpty(feature = null, configuration) {
        const initialData = {
            priceListCode: '',
            paymentTermCode: '',
            customerGroupCode: '',
            paymentMethod: '',
            segment: '',
            horecaSubcategory: '',
        };
        return new CommercialTermsForm(initialData, feature, configuration);
    }

    static newFor(commercialTerms, feature = null, configuration) {
        return new CommercialTermsForm(commercialTerms, feature, configuration);
    }

    constructor(initialData = {}, feature = null, configuration) {
        const form = super({}, null, feature, configuration);

        const fields = {
            priceList: new OptionField(feature.priceListsCodes(), this.isOptional('priceList'), feature, initialData.priceListCode),
            paymentTerm: new OptionField(feature.paymentTermsCodes(), this.isOptional('paymentTerm'), feature, initialData.paymentTermCode, true),
            customerGroup: new OptionField(feature.customerGroupsCodes(), this.isOptional('customerGroup'), feature, initialData.customerGroupCode),
            paymentMethod: new OptionField(feature.paymentMethods(), this.isOptional('paymentMethod'), feature, initialData.paymentMethod),
            segment: new OptionField(feature.segments(), this.isOptional('segment'), feature, initialData.segment),
            horecaSubcategory: new OptionField(feature.horecaSubcategories(), this.isOptional('horecaSubcategory'), feature, initialData.horecaSubcategory)
        };

        form.setFields(fields);

        makeObservable(this, {
            priceListValue: computed,
            paymentTermValue: computed,
            customerGroupValue: computed,
            paymentMethodValue: computed,
            segmentValue: computed,
            horecaSubcategoryValue: computed,
        });
    }

    configurationFieldNameMapping() {
        return {
            priceList: '_price_list_code',
            paymentTerm: '_payment_term_code',
            paymentMethod: '_payment_method',
            customerGroup: '_customer_group_code',
            segment: '_segment',
            horecaSubcategory: '_horeca_subcategory',
        }
    }

    priceList() {
        return this.getFieldByName('priceList').value;
    }

    paymentTerm() {
        return this.getFieldByName('paymentTerm').value;
    }

    customerGroup() {
        return this.getFieldByName('customerGroup').value;
    }

    paymentMethod() {
        return this.getFieldByName('paymentMethod').value;
    }

    segment() {
        return this.getFieldByName('segment').value;
    }

    horecaSubcategory() {
        return this.getFieldByName('horecaSubcategory').value;
    }

    get priceListValue() {
        return this.priceList();
    }

    get paymentTermValue() {
        return this.paymentTerm();
    }

    get customerGroupValue() {
        return this.customerGroup();
    }

    get paymentMethodValue() {
        return this.paymentMethod();
    }

    get segmentValue() {
        return this.segment();
    }

    get horecaSubcategoryValue() {
        return this.horecaSubcategory();
    }
}
